import { render, staticRenderFns } from "./ViewPaymentCard.vue?vue&type=template&id=147bae8c&scoped=true"
import script from "./ViewPaymentCard.vue?vue&type=script&lang=js"
export * from "./ViewPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./ViewPaymentCard.vue?vue&type=style&index=0&id=147bae8c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bae8c",
  null
  
)

export default component.exports